<template>
	<component
		:is="componentTag"
		:class="[$style[type], textAlign && $style[textAlign]]"
		:data-test="dataTest"
	>
		<slot />
	</component>
</template>

<script lang="ts" setup>
import type { Align } from '../common-text/common-text';
import type { HeadingType } from './common-heading';

type Props = {
	type: HeadingType;
	textAlign?: Align;
	tag?: HeadingType | 'div';
	dataTest?: string;
};

const props = withDefaults(defineProps<Props>(), {
	dataTest: 'heading',
	tag: undefined,
	textAlign: undefined,
});

const componentTag = computed(() => {
	if (props.tag) return props.tag;

	// If the type is a heading, return the corresponding heading tag
	return props.type;
});
</script>
<style lang="css" module>
.h1,
.h2,
.h3,
.h4,
.h5 {
	margin: 0;
	color: var(--surface--on-surface);
	font-family: var(--typography--font-family-heading);
	font-weight: var(--typography--bold);
}

.h1 {
	font-size: var(--typography--h1-size);
	line-height: var(--typography--h1-line-height);
	text-transform: var(--common-heading-h1-text-transform, none);
}

.h2 {
	font-size: var(--typography--h2-size);
	line-height: var(--typography--h2-line-height);
	text-transform: var(--common-heading-h2-text-transform, none);
}

.h3 {
	font-size: var(--typography--h3-size);
	line-height: var(--typography--h3-line-height);
	text-transform: var(--common-heading-h3-text-transform, none);
}

.h4 {
	font-size: var(--typography--h4-size);
	line-height: var(--typography--h4-line-height);
	text-transform: var(--common-heading-h4-text-transform, none);
}

.h5 {
	font-size: var(--typography--h5-size);
	line-height: var(--typography--h5-line-height);
}

.left {
	text-align: left;
}
.right {
	text-align: right;
}
.center {
	text-align: center;
}
</style>
